import { PlayIcon } from "@heroicons/react/24/outline";
import RunProcessModal from "@via/pages/projects/pipelines/workflow/components/create-edit-process-form/run-process-modal.tsx";
import { useState, type FC } from "react";

interface ProcessRunButtonProps {
  processId: number;
}

/**
 * Opens a modal that creates an unlaunched run attempt for this process alone, then routes to
 * the run detail page (POST /api/v1/process/{processId}/run-attempt, Task 8). The button itself
 * carries no permission check: the process editor already knows whether the current user can
 * edit this process (canEditProcess), and gates rendering this component on that, the same way
 * it gates the Save buttons. A caller who somehow reaches the endpoint without write permission
 * still gets refused server side with a 403.
 */
const ProcessRunButton: FC<ProcessRunButtonProps> = ({ processId }) => {
  const [isRunModalOpen, setIsRunModalOpen] = useState(false);

  return (
    <>
      <button
        id="run-process-button"
        type="button"
        onClick={() => setIsRunModalOpen(true)}
        className="inline-flex items-center gap-x-1.5 rounded-md border border-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
        <PlayIcon className="h-4 w-4" aria-hidden="true" />
        Run
      </button>
      {isRunModalOpen && (
        <RunProcessModal
          open={isRunModalOpen}
          setOpen={setIsRunModalOpen}
          processId={processId}
        />
      )}
    </>
  );
};

export default ProcessRunButton;
